import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { CurrencyState } from "../../models/mp-common/currency-state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class CurrencyGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.currencies.get),
			withLatestFrom(this.store.select(MpCommonSelectors.currencies)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.currencies.getSuccess(state))
					: of(MpCommonActions.currencies.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.currencies.getApi),
			switchMap(() => {
				return this.marketplaceService.currencies().pipe(
					map((countries) =>
						MpCommonActions.currencies.getSuccess({
							currencies: _.sortBy(countries, "code"),
							loading: false
						})
					),
					catchError((error) =>
						of(MpCommonActions.currencies.getFail(new FailState(error)))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private marketplaceService: MpCommonService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: CurrencyState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
